import styled from "styled-components";
import Logo from '../../assets/logo.svg'
const S = {
    Wrapper: styled.footer`
    z-index: 9;
    // background-color: #002a32;
    // background-image: linear-gradient(to right, #d41031, #e04152, #e86271, #ed7f8e, #f09baa);
    /* padding:40px; */
    // margin:40px;
    // border-radius:20px;
    .copyright{
        // opacity:0.7;
       
        padding: 20px 0px;
        color:white;
        font-size:12px;
        margin:0px 40px;
        text-align:center;
        span{
            text-align:center;
        }
        .call{
            background:white;
            padding:10px;
            margin-left:20px;
            border-radius:10px;
            &:hover{
                background:#93faa5;
            }
        }
        a{
            text-decoration: none;
            color:white;
            transition: 500ms ease;
            &:visited{
                color:white;
            }
            &:hover{
                color:black;
                transition: 500ms ease;
            }
        }
    }
    p{
        color:white;
        text-align:center;
        width:70%;
    }
    `,
    Section: styled.section`
    margin: 40px;
    display:flex;
    flex-direction:column;
    // grid-area: content;
    gap:20px;
    .dislink{
        display:flex;
        flex-direction:row;
        text-decoration:none;
        color:black;
        align-items:center;
        gap:20px;
        img{
            width:100px;
        }
        &:hover{
            color:#00a9c5;
        }
    }
 
    .banner{
        display:flex;
        flex-direction:row;
        position:relative;
        align-items:center;
        @media (max-width:648px){
            flex-direction:column;
        }
        .imgwrap{
            position:relative;
            width:50%;
            height:300px;
            @media (max-width:648px){
                width:100%;
            }
            .foregroundImg{
                width:100%;
                cursor: pointer;
                position: relative;
                z-index: 2;
                border-radius:16px;

                height:300px;
                object-fit:cover;
                
            }
            .backgroundImg{
                height:300px;
                object-fit:cover;
                width:100%;
                position: absolute;
                top: 2px;
                left: 0;
                transform: scale(1.05);
                transition: all 0.5s ease;
                opacity: 1;
                filter: blur(24px);
                z-index: 1;
            }
        }
        
			
        .baslik{
            /* From https://css.glass */
           
            width:50%;
            // position:absolute;
            // bottom:20px;
            // right:20px;
            // padding:40px;
            @media (max-width:648px){
                width:100%;
            }
            h1{
                color:#01aecb;
                font-size:4em;
                font-weight:900;
                margin:0px;
                @media (max-width:648px){
                    font-size:2em;
                    width:100%;
                        }
            }
        }
    }
    h3{
        color:#01aecb;
        font-size:2em;
    }
    `,
}

export default S